// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundPage_wrapper__PUUOM","text":"NotFoundPage_text__mKB3v","code":"NotFoundPage_code__uQLVM","button":"NotFoundPage_button__rGgQb"};